const RESOURCE_NAME = '/orchestrator';

export default axios => ({
	tenantMirror(userId, name, params) {
		return axios.post(`${RESOURCE_NAME}/mirror/${userId}`, {name}, {params});
	},
	getMintDeckSession() {
		return axios.get(`${RESOURCE_NAME}`, {});
	},
	getMintEmbed(module) {
		return axios.get(`${RESOURCE_NAME}/mint-embed/${module}`, {});
	},
	userEdit(userId, data, params) {
		return axios.post(`${RESOURCE_NAME}/user/${userId}/edit`, data, {params});
	},
	rootEmail(userId, params) {
		return axios.post(`${RESOURCE_NAME}/user/${userId}/root-email`, {}, {params});
	},
	getStatus(userId) {
		return axios.get(`${RESOURCE_NAME}/user/${userId}/status`, {});
	},
	getUsers(userId, params) {
		if(!userId) return axios.get(`${RESOURCE_NAME}/user`, {params});
		return axios.get(`${RESOURCE_NAME}/user/${userId}`, {params});
	},
});